<div class="tvd-overall flex flex-col gap-2">
    <div id="total-value-delivered-heading">
        <p class="text-base font-medium !my-0">Total Value Delivered</p>
    </div>

    <ng-container *ngIf="!value?.monetaryContribution; else valueContent">
        <loader size="medium"></loader>
    </ng-container>

    <ng-template #valueContent>
        <div class="overall-tvd-value flex flex-col gap-2">
            <div class="flex items-end gap-2">
                <div>
                    <span class="tvd-currency-symbol text-5xl font-normal">{{currencyCode | currencySymbol}}</span>
                    <span class="tvd-monetary-value text-6xl">{{displayInRoundedNumber ? (totalValueDelivered.currentMonetaryContribution | abbreviateNumber) : totalValueDelivered.currentMonetaryContribution}}</span>
                </div>

                <div>
                    <span class="tvd-currency-code text-2xl">{{currencyCode}}</span>
                </div>
            </div>

            <span class="tvd-default-message text-sm" *ngIf="totalValueDelivered.isMonetaryContributionModified">(TVD differs due to changed cost assumptions/custom tiles)</span>
        </div>

        <div class="default-overall-tvd-value flex items-end gap-2" *ngIf="totalValueDelivered.isMonetaryContributionModified">
            <div class="text-4xl">
                <span class="mr-4">Default</span>
                <span class="tvd-currency-symbol">{{currencyCode | currencySymbol}}</span>
                <span class="tvd-monetary-value">{{displayInRoundedNumber ? (totalValueDelivered.defaultMonetaryContribution | abbreviateNumber) : totalValueDelivered.defaultMonetaryContribution}}</span>
            </div>
            <span class="tvd-currency-code text-2xl">{{currencyCode}}</span>
        </div>
    </ng-template>
</div>
